import { SelectInputV2, TextArea, TextInput } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { ProductType } from '@frontend/product/types';

import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import useEnterProductInformation from './enter-product-information.controller';

const ID = 'wizard-enter-product-information';

const productTypeOptions = [
    { value: ProductType.CONSUMABLE, label: ProductType.CONSUMABLE, display: CommonMessage.OBJECTS.CONSUMABLE.DEFAULT },
    { value: ProductType.EQUIPMENT, label: ProductType.EQUIPMENT, display: CommonMessage.OBJECTS.EQUIPMENT.DEFAULT },
    { value: ProductType.KIT, label: ProductType.KIT, display: CommonMessage.OBJECTS.PRODUCT.KIT }
];

const EnterProductInformation = (props: { wizard_id: string }) => {
    const viewProps = useEnterProductInformation(props);

    useWizardModalScreenNavigation({
        onContinue: viewProps.onSubmit,
        continueDisabled: viewProps.submitDisabled
    });

    return (
        <div
            id={ID}
            className='flex w-full flex-col gap-4'>
            <div className='text-foreground-default text-base font-medium'>{CommonMessage.FORMS.BASIC_INFORMATION}</div>

            <div className='outline-border-default flex flex-col gap-4 rounded-xl p-4 outline-1'>
                <TextInput
                    id={`${ID}-name`}
                    required
                    label={CommonMessage.OBJECTS.COMMON_FIELDS.NAME}
                    value={viewProps.product.name}
                    onChange={(value) => viewProps.setProduct((prev) => ({ ...prev, name: value }))}
                />
                <SelectInputV2<ProductType>
                    id={`${ID}-type`}
                    required
                    label={CommonMessage.OBJECTS.PRODUCT.PRODUCT_TYPE}
                    options={productTypeOptions}
                    value={viewProps.product.type}
                    onSelect={(option) => viewProps.setProduct((prev) => ({ ...prev, type: option?.value as ProductType | undefined }))}
                    disableSearch
                />
                <TextInput
                    id={`${ID}-sku`}
                    label={CommonMessage.OBJECTS.PRODUCT.SKU}
                    value={viewProps.product.sku}
                    onChange={(value) => viewProps.setProduct((prev) => ({ ...prev, sku: value || null }))}
                    isClearable
                />
                <TextInput
                    id={`${ID}-ean`}
                    label={CommonMessage.OBJECTS.PRODUCT.EAN}
                    value={viewProps.product.ean}
                    onChange={(value) => viewProps.setProduct((prev) => ({ ...prev, ean: value || null }))}
                    isClearable
                />
                <TextArea
                    id={`${ID}-description`}
                    label={CommonMessage.OBJECTS.COMMON_FIELDS.DESCRIPTION}
                    value={viewProps.product.description}
                    onChange={(value) => viewProps.setProduct((prev) => ({ ...prev, description: value || null }))}
                    submitted={false}
                />
                <TextArea
                    id={`${ID}-user-info`}
                    label={CommonMessage.OBJECTS.PRODUCT.USER_INFO}
                    value={viewProps.product.user_info}
                    onChange={(value) => viewProps.setProduct((prev) => ({ ...prev, user_info: value || null }))}
                    submitted={false}
                />
            </div>
        </div>
    );
};

export default EnterProductInformation;
